module.exports = __webpack_public_path__ + "static/media/fulcro-white.2f87179a.svg";